/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import alertComponents from "../components/Alarm/AlertComponents";
import { useTranslate } from "../hooks/LanguageProvider";
import SelectReport from "../components/Vehicle/SelectReport";
import { Form } from "react-bootstrap";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams, Link } from "react-router-dom";
import usePermissions from '../hooks/usePermissions';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface Dispositif {
    id: string;
    value: string;
}

interface AlarmInterface {
    id_alarme: string;
    id_user?: string;
    items: Dispositif[];
    alarm_type: number;
    id_type_alarme: number;
    alarm_metrics: string;
    alarm_name: string;
    id_alarm_group: number;
    date_creation?: string;
    date_modification?: string;
    name_groupe_alarme: string;
    id_groupe_alarme: number;
}

interface Vehicle {
    immatriculation_vehicule: string;
    id_dispositif: number;
}

interface Driver {
    nom_conducteur: string;
    prenom_conducteur: string;
    id_conducteur: number;
}

const Alarm: React.FC = () => {
    const [step, setStep] = useState(1);
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const { id_alarme } = useParams<{ id_alarme?: string }>();
    const [loading, setLoading] = useState(true);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [inputTypeSearchValue, setTypeSearchValue] = useState<number>(11);
    const [inputTypeSearchLabel, setTypeSearchLabel] = useState<string>(
        translate("Matriculation")
    );
    const [inputAdvanceSearch, setInputAdvancedSearch] =
        useState<string>("Vehicle");
    const [InputAdvanceSearchGroup, setInputAdvancedSearchGroup] =
        useState<string>("Group");
    const [itemsAlerts, setItemsAlerts] = useState<{ value: any; id: any }[]>([]);
    const [SelectReportState, setSelectReportState] = useState(false);
    const [SelectGroupState, setSelectGroupState] = useState(false);
    const [SearchByIcon, setSearchByIcon] = useState("filter");
    const [autocompleteStateIcon, setAutocompleteStateIcon] = useState("search");
    let [alarmFor, setAlarmFor] = useState("Vehicles");
    let [itemSearch, setItemSearch] = useState("");
    let [itemGroupSearch, setItemGroupSearch] = useState("");
    let [itemGroupName, setItemGroupName] = useState("");
    const id_user = localStorage.getItem("userid");
    const [autocompleteState, setAutocompleteState] = useState("");
    const [autocompleteGroupState, setAutocompleteGroupState] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [alarmSuggestions, setAlarmSuggestions] = useState([]);
    const [checkboxStates, setCheckboxStates] = useState<{
        [key: string]: boolean;
    }>({});
    const [selectAll, setSelectAll] = useState(false);
    const [createButtonDisabled, setCreateButtonDisabled] = useState(false);
    const [groupsOptions, setGroupsOptions] = useState<any[]>([
        { value: "Aucun", label: "Aucun" },
    ]);
    const [group, setGroups] = useState<any[]>();

    const [Alarm, setAlarm] = useState<AlarmInterface>({
        id_user: id_user ?? undefined,
        id_alarme: id_alarme ?? "0",
        items: [],
        alarm_type: 0,
        id_type_alarme: 0,
        alarm_metrics: "",
        alarm_name: "",
        id_alarm_group: 0,
        name_groupe_alarme: "",
        id_groupe_alarme: 0,
    });

    const normalizeAlarmItems = (items: any[] = []): Dispositif[] =>
        items
            .filter((item) => item && item.id !== undefined && item.value !== undefined)
            .map((item) => ({
                id: item.id.toString(),
                value: item.value.toString(),
            }));

    const getCheckedItems = (
        states: { [key: string]: boolean },
        sourceItems: { value: any; id: any }[] = itemsAlerts
    ): Dispositif[] =>
        normalizeAlarmItems(sourceItems).filter((item) => states[item.value]);

    const applySelectedItems = (items: any[], checked = true) => {
        const normalizedItems = normalizeAlarmItems(items);
        const nextCheckboxStates: { [key: string]: boolean } = {};

        normalizedItems.forEach((item) => {
            nextCheckboxStates[item.value] = checked;
        });

        setItemsAlerts(normalizedItems);
        setCheckboxStates(nextCheckboxStates);
        setSelectAll(checked && normalizedItems.length > 0);
        setIsCreateButtonDisabled(!checked || normalizedItems.length === 0);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: checked ? normalizedItems : [],
        }));

        return normalizedItems;
    };

    const resetAlarmTargetSelection = () => {
        setItemSearch("");
        setSuggestions([]);
        setAutocompleteState("autocomplete-state");
        setAutocompleteStateIcon("search");
        setItemsAlerts([]);
        setCheckboxStates({});
        setSelectAll(false);
        setIsCreateButtonDisabled(true);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: [],
        }));
    };

    const getMetricValue = (key: string, fallback: any) => {
        try {
            const metrics =
                typeof Alarm.alarm_metrics === "string"
                    ? JSON.parse(Alarm.alarm_metrics || "{}")
                    : Alarm.alarm_metrics || {};

            return metrics[key] ?? fallback;
        } catch (error) {
            return fallback;
        }
    };


    const roleId = localStorage.getItem("id_role");


    const { userPermissions } = usePermissions(roleId);


    function mapPermissionIdToReportId(permissionId: number): number | null {
        const mapping: Record<number, number> = {
            88: 2,
            89: 3,
            90: 4,
            91: 5,
            92: 6,
            93: 7,
            94: 8,
            95: 9,
            96: 10,
            97: 11,
            98: 12,
            99: 13,
            100: 14,
            101: 15,
            102: 16,
            103: 17,
            104: 18,
            105: 19,
            106: 20,
            107: 21,
            108: 22,
            109: 23,
            110: 24,
            111: 25,
            112: 26,
            113: 27,
            114: 28,
            115: 29,
            116: 30,
            117: 31,
            118: 32,
            119: 33,
            120: 34,
            121: 35,
            122: 36,
            123: 37,
            124: 38,
            125: 39,
            126: 40,
            127: 41,
            128: 42,
            129: 43,
            130: 44,
            131: 45,
            132: 46,
            133: 47,
            134: 48,
            135: 49,
            136: 50
        };

        return mapping[permissionId] ?? null;
    }



    const allAlarmsData: { [key: number]: string } = {
        88: translate("Outside POI during forbidden time"),
        89: translate("No transmission"),
        90: translate("Accelerometer alarm (device)"),
        91: translate("iButton authentication alarm (device)"),
        92: translate("GPS jamming alarm (device)"),
        93: translate("GSM jamming alarm (device)"),
        94: translate("CAN alarm (device)"),
        95: translate("SIM credit alarm"),
        96: translate("iButton group alarm (device)"),
        97: translate("I/O alarm"),
        98: translate("Private mode alarm (device)"),
        99: translate("Specific iButton alarm (device)"),
        100: translate("Power interruption"),
        101: translate("Battery discharged (device)"),
        102: translate("Motion sensor (device)"),
        103: translate("Date/Time"),
        104: translate("Speed violation (device)"),
        105: translate("iButton error (device)"),
        106: translate("Ignition status (device)"),
        107: translate("Relay status (device)"),
        108: translate("Panic status (device)"),
        109: translate("Event counter EV1 increment"),
        110: translate("Event counter EV2 increment"),
        111: translate("Garmin interface or screen disconnected (device)"),
        112: translate("Engine started during forbidden time"),
        113: translate("Movement with engine off (device)"),
        114: translate("Memory full (device)"),
        115: translate("GPS signal level"),
        116: translate("GSM signal level"),
        117: translate("Number of resets"),
        118: translate("CAN odometer"),
        119: translate("GPS odometer"),
        120: translate("Points of interest"),
        121: translate("Relay activated"),
        122: translate("Relay disconnected (device)"),
        123: translate("CAN engine speed"),
        124: translate("Unknown GSM network"),
        125: translate("Invalid GPS signal (device)"),
        126: translate("Under-voltage (device)"),
        127: translate("Idling with engine on"),
        128: translate("Idling with engine on (device)"),
        129: translate("Vehicle parked with engine off (device)"),
        130: translate("Over-voltage (device)"),
        131: translate("CAN engine temperature"),
        132: translate("Daily mobile traffic (device)"),
        133: translate("Monthly mobile traffic (device)"),
        134: translate("Speed"),
        135: translate("POI Entry/Exit"),
        136: translate("POI Speed Violation")
    };


    const alarmsData: { [key: number]: string } = Object.fromEntries(
        userPermissions
            .map((perm) => mapPermissionIdToReportId(perm.id_permission)) // ✅ corrige ici
            .filter((id): id is number => id !== null)
            .map((id) => [id, allAlarmsData[id]])
    );


    const addAlarmParams = () => {
        // Add logic here to go to the next step and load the alarm settings
        setStep(2);
    };

    const wizardBack = () => {
        setStep(step - 1);
    };

    const checkStep3 = () => {
        // Add logic here to check form fields from step 3
        console.log("Checking step 3");
    };

    //Alerts components
    const [selectedAlarm, setSelectedAlarm] = useState<number | null>(null);

    const handleAlarmTypeChange = (typeAlert: string) => {
        const value = parseInt(typeAlert, 10);
        setSelectedAlarm(value !== 0 ? value : null);
        console.log(value + "=" + Alarm.id_type_alarme);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_metrics:
                value === Alarm.id_type_alarme
                    ? Alarm.alarm_metrics
                    : createEmptyMetrics(value),
            alarm_type: value,
        }));
    };

    const createEmptyMetrics = (alarmType: number): any => {
        const keepPreviousMetrics = Number(Alarm.id_type_alarme) === alarmType;
        const metric = (key: string, fallback: any) =>
            keepPreviousMetrics ? getMetricValue(key, fallback) : fallback;

        switch (alarmType) {
            case 2:
                return {
                    type: "PoiAlarm",
                    ids: metric("ids", []),
                };
            case 3:
                return {
                    type: "AbsenceOfTransmission",
                    hours: metric("hours", "48"),
                };
            case 4:
                return {
                    type: "AccelerometreAlarm",
                };
            case 5:
                return {
                    type: "AuthentificationButtonAlarm ",
                };
            case 6:
                return {
                    type: "BrouillageGPSAlarm",
                };
            case 7:
                return {
                    type: "BrouillageGSMAlarm",
                };
            case 8:
                return {
                    type: "CANAlarm",
                };
            case 9:
                return {
                    type: "SIMCreditAlarm",
                    credit_Threshold: metric("credit_Threshold", 200),
                };
            case 10:
                return {
                    type: "GroupeButtonAlarm",
                };
            case 11:
                return {
                    type: "I/O Alarm",
                };
            case 12:
                return {
                    type: "PrivateModeAlarm",
                };
            case 13:
                return {
                    type: "specificButtonAlarm",
                };
            case 14:
                return {
                    type: "powerAlarm ",
                    powerDisconnected: metric("powerDisconnected", false),
                };
            case 15:
                return {
                    type: "BatteryAlarm ",
                    batteryThreshold: metric("batteryThreshold", 50),
                };
            case 16:
                return {
                    type: "MotionSensor",
                };
            case 17:
                return {
                    type: "DateTimeAlarm",
                    datetime: metric("datetime", ""),
                };
            case 18:
                return {
                    type: "SpeedExceedAlarm",
                    speed_limit: metric("speed_limit", 90),
                };
            case 19:
                return {
                    type: "ButtonErreur  ",
                };
            case 20:
                return {
                    type: "Motor Contact Status",
                };
            case 21:
                return {
                    type: "RelayStatus",
                };
            case 22:
                return {
                    type: "Panic state",
                };

            case 23: // IncrementCounterEV1
                return {
                    type: "IncrementCounterEV1",
                    //        counter_value: Alarm.id_type_alarme == 23 ? JSON.parse(Alarm.alarm_metrics).counter_value : 0 // Default value
                };
            case 24:
                return {
                    type: "IncrementCounterEV2",
                };
            case 25: // InterfaceOrGarminScreenDisconnected
                return {
                    type: "InterfaceOrGarminScreenDisconnected",
                };
            case 26: // EngineStartedDuringRestrictedTime
                return {
                    type: "EngineStartedDuringRestrictedTime",
                };
            case 27: // MovementWithEngineOff
                return {
                    type: "MovementWithEngineOff",
                };
            case 28: // MemoryFull
                return {
                    type: "MemoryFull",
                };
            case 29:
                return {
                    type: "GPSSignalAlarm ",
                    threshold: metric("threshold", 50),
                };
            case 30:
                return {
                    type: "GsmSignalAlarm ",
                    threshold: metric("threshold", 50),
                };
            case 31:
                return {
                    type: "ResetAlarm ",
                    threshold: metric("threshold", 0),
                };
            case 32: // OdometerCAN
                return {
                    type: "OdometerCAN",
                    threshold: metric("threshold", 1000),
                };
            case 33: // OdometerGPS
                return {
                    type: "OdometerGPS",
                    threshold: metric("threshold", 2000),
                };
            case 34: //PointsOfInterest
                return {
                    type: "PointsOfInterest",
                };
            case 35: // RelayActivated
                return {
                    type: "RelayActivated",
                };
            case 36: // RelayDisconnected
                return {
                    type: "RelayDisconnected",
                };
            case 37: // EngineSpeedCAN
                return {
                    type: "EngineSpeedCAN",
                    rpm_threshold: metric("rpm_threshold", 3000),
                };
            case 38: // UnknownGSMNetwork
                return {
                    type: "UnknownGSMNetwork",
                };
            case 39: // InvalidGPSSignal
                return {
                    type: "InvalidGPSSignal",
                };
            case 40: // UnderVoltage
                return {
                    type: "UnderVoltage",
                    undervoltage_threshold: metric("undervoltage_threshold", 11.5),
                };
            case 41: // StationaryWithEngineOn
                return {
                    type: "StationaryWithEngineOn",
                };
            case 42: // StationaryWithEngineOnDevice
                return {
                    type: "StationaryWithEngineOnDevice",
                };
            case 43: // ParkingWithEngineOff
                return {
                    type: "StationaryWithEngineOff",
                };
            case 44: // OverVoltage
                return {
                    type: "OverVoltage",
                    overvoltage_threshold: metric("overvoltage_threshold", 15.0),
                };
            case 45: // EngineTemperatureCAN
                return {
                    type: "EngineTemperatureCAN",
                    temperature_threshold: metric("temperature_threshold", 95),
                };
            case 46: // DailyMobileData
                return {
                    type: "DailyMobileData",
                    daily_data_limit_mb: metric("daily_data_limit_mb", 500),
                };
            case 47: // MonthlyMobileData
                return {
                    type: "MonthlyMobileData",
                    monthly_data_limit_mb: metric("monthly_data_limit_mb", 10000),
                };
            case 48: // SpeedAlarm
                return {
                    type: "SpeedAlarm",
                    max_speed: metric("max_speed", 80),
                };

            case 49: //   POI Entry/Exit
                return {
                    type: "POIEntryExit",
                    ids: metric("ids", []),
                };

            case 50: // POI Speed Violation
                return {
                    type: "POISpeedViolation",
                    max_speed: metric("max_speed", 80),
                    duration: metric("duration", 5),
                    ids: metric("ids", []),
                };

            default:
                return {}; // By default, returns an empty object.
        }
    };

    const updateMetrics = (newMetrics: any) => {
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_metrics: newMetrics,
        }));
    };

    const handleAlarmMetricsChange = (newMetrics: any) => {
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_metrics: newMetrics,
        }));
    };

    // In the render method of the Alarm component
    let AlarmComponent =
        selectedAlarm !== null && alertComponents[selectedAlarm]
            ? React.createElement(alertComponents[selectedAlarm], {
                alarm: Alarm.alarm_metrics,
                onChange: handleAlarmMetricsChange,
            })
            : null;

    const [searchTypeOptions, setSearchTypeOptions] = useState([
        { value: "11", label: "Matriculation" },
        { value: "12", label: "PSN" },
        { value: "14", label: "Vehicle group" },
        { value: "15", label: "User" },
    ]);

    const addReportBy = async (type: string) => {
        if (type == "1") {
            setAlarmFor("Vehicles");
        } else {
            setAlarmFor("Drivers");
        }

        try {
            setLoading(true);

            const res = await fetch(`${backendUrl}/api/search/report-for/${type}`, {
                mode: "cors",
            });
            const data = await res.json();

            const optionsArray = data["data"][0]["searchfor"].split(",");
            setSearchTypeOptions(
                optionsArray.map((option: any, index: any) => ({
                    value: type.toString() + (index + 1).toString(),
                    label: translate(option.trim()),
                }))
            );

            setTypeSearchValue(parseInt(type.toString() + "1"));
            console.log("Autocomplete: " + type);

            setTypeSearchLabel(translate(optionsArray[0]));
            setInputAdvancedSearch(translate(optionsArray[0]));

            resetAlarmTargetSelection();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const searchBy = async (option: any) => {
        setInputAdvancedSearch(translate(option.label));
        setTypeSearchLabel(translate(option.label));
        setTypeSearchValue(option.value);
        resetAlarmTargetSelection();
    };

    const getAutocomplete = async (search: string) => {
        setItemSearch(search);
        setAutocompleteState("");
        setAutocompleteStateIcon("spinner");

        try {
            if (search.trim() !== "") {
                const res = await fetch(
                    `${backendUrl}/api/search/${inputTypeSearchValue}/${search}/${id_user}`,
                    { mode: "cors" }
                );
                const data = await res.json();

                const getSuggestions = data.data.map((item: any) => {
                    let newItem: any = {};

                    if (inputTypeSearchValue == 11 || inputTypeSearchValue == 34) {
                        newItem.value = item.immatriculation_vehicule;
                        newItem.id = item.id_dispositif;
                    } else if (inputTypeSearchValue == 12) {
                        newItem.value = item.psn_dispositif;
                        newItem.id = item.id_dispositif;
                    } else if (inputTypeSearchValue == 14) {
                        newItem.value = item.nom_groupe;
                        newItem.id = item.id_groupe;
                    } else if (inputTypeSearchValue == 15) {
                        newItem.value = item.username_user;
                        newItem.id = item.id_user;
                    } else if (inputTypeSearchValue == 31 || inputTypeSearchValue == 51) {
                        newItem.value = item.nom_conducteur + " " + item.prenom_conducteur;
                        newItem.id = item.id_dispositif;
                    } else if (inputTypeSearchValue == 33) {
                        newItem.value = item.nom;
                        newItem.id = item.id_agence;
                    } else if (inputTypeSearchValue == 32) {
                        newItem.value = item.username_user;
                        newItem.id = item.id_user;
                    }

                    return newItem;
                });

                setSuggestions(getSuggestions);
                setAutocompleteStateIcon("search");

                getSuggestions.forEach((item: { value: any }) => {
                    updateCheckboxState(item.value);
                });
            } else {
                setAutocompleteStateIcon("search");
                setSuggestions([]);
            }
        } catch (error) {
            setAutocompleteStateIcon("search");
            setSuggestions([]);
        }
    };

    const getGroupsAlarm = async (name_groupe: string) => {
        setItemGroupSearch(name_groupe);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            id_groupe_alarme: 0,
            name_groupe_alarme: "",
        }));

        if (!name_groupe.trim()) {
            setAlarmSuggestions([]);
            setAutocompleteGroupState("autocomplete-state");
            setAutocompleteStateIcon("search");
            return;
        }

        setAutocompleteGroupState("");
        setAutocompleteStateIcon("spinner");

        try {
            const bodyData = JSON.stringify({
                id_user,
                name_groupe,
            });

            const groupsData = await fetch(`${backendUrl}/api/alarm/group-options`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: bodyData,
                mode: "cors",
            });

            const data = await groupsData.json();

            const groupsOptionsData = data.map((group: any) => ({
                value: group.id_groupe_alarme,
                label: `${group.name_groupe_alarme || ""}`,
            }));

            setGroupsOptions(groupsOptionsData);
            setAlarmSuggestions(groupsOptionsData);
        } catch (error) {
            setAlarmSuggestions([]);
        } finally {
            setAutocompleteStateIcon("search");
        }
    };
    const handleSelectAllChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const { checked } = event.target;

        // Update the state for "select all"
        setSelectAll(checked);

        // Update the checkbox states
        const updatedCheckboxStates: { [key: string]: boolean } = {};
        itemsAlerts.forEach((item: any) => {
            updatedCheckboxStates[item.value] = checked;
        });
        setCheckboxStates(updatedCheckboxStates);

        // Build the list of selected alarms
        const selectedAlarms: Dispositif[] = checked ? normalizeAlarmItems(itemsAlerts) : [];

        // Update the alarm state
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: selectedAlarms, // Update the list of alarms
        }));

        // Check if any alarms are selected to enable/disable the "Create" button
        setIsCreateButtonDisabled(selectedAlarms.length == 0);

        console.log(selectedAlarms);
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked, id } = event.target; // Get the checkbox element's ID (unique)

        setCheckboxStates((prevState) => ({
            ...prevState,
            [name]: checked,
        }));

        const updatedCheckboxStates = {
            ...checkboxStates,
            [name]: checked,
        };

        // Check if at least one checkbox is selected
        const anySelected = Object.values(updatedCheckboxStates).some(
            (value) => value
        );
        setIsCreateButtonDisabled(!anySelected);

        // Create the list of selected alarms, ensuring that the ID and value are correctly defined
        const selectedAlarms = getCheckedItems(updatedCheckboxStates);

        // Update the alarm state with the correct structure
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: selectedAlarms, // Update items with Dispositif[]
            id_alarme: prevAlarm.id_alarme,
            alarm_type: prevAlarm.alarm_type,
            id_type_alarme: prevAlarm.id_type_alarme,
            alarm_metrics: prevAlarm.alarm_metrics,
            alarm_name: prevAlarm.alarm_name,
            id_alarm_group: prevAlarm.id_alarm_group,
            name_groupe_alarme: prevAlarm.name_groupe_alarme,
        }));
        setSelectAll(selectedAlarms.length > 0 && selectedAlarms.length === itemsAlerts.length);

        console.log(selectedAlarms); // Check the data after update
    };

    // const setItems = async (newItem: any) => {
    //     const itemExists = itemsAlerts.some((item) => item.value === newItem.value);

    //     if (!itemExists) {
    //         const updatedItemsAlarms = [...itemsAlerts, newItem];
    //         setItemsAlerts(updatedItemsAlarms);

    //         setAlarm(prevAlarm => ({
    //             ...prevAlarm,
    //             items: updatedItemsAlarms
    //         }));

    //         setAutocompleteState("autocomplete-state");
    //         setItemSearch(newItem.value);
    //         handleAlarmSelect(updatedItemsAlarms);
    //         updateCheckboxState(newItem);

    //     } else {
    //         setAutocompleteState("autocomplete-state");
    //         alert("The item already exists in the list...");
    //         console.log("The item already exists in the list..");
    //     }

    // };

    const getAutocompleteVehicle = async (id_user: number) => {
        setItemSearch("");
        setAutocompleteState("");
        try {
            const res = await fetch(`${backendUrl}/api/search/vehicle`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    id_user: id_user,
                }),
            });

            const data = await res.json();

            const getSuggestions = data.map((item: any) => {
                let newItem: any = {};

                newItem.value = item.immatriculation_vehicule;
                newItem.id = item.id_dispositif;

                return newItem;
            });

            applySelectedItems(getSuggestions);

            setAutocompleteState("");

            return getSuggestions;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const getAutocompleteVehicleByGroup = async (id_groupe: number) => {
        setItemSearch("");
        setAutocompleteState("");
        try {
            const res = await fetch(`${backendUrl}/api/search/group-vehicles`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    id_groupe: id_groupe,
                }),
            });

            const data = await res.json();

            const getSuggestions = data.map((item: any) => {
                let newItem: any = {};
                newItem.value = item.immatriculation_vehicule;
                newItem.id = item.id_dispositif;

                return newItem;
            });

            applySelectedItems(getSuggestions);

            setAutocompleteState("");

            return getSuggestions;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const getAutocompleteDriversByIdUser = async (id_user: number) => {
        //setItemSearch("");
        setAutocompleteState("");
        try {
            const res = await fetch(`${backendUrl}/api/search/drivers`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    id_user: id_user,
                }),
            });

            const data = await res.json();

            // console.log(data)

            const getSuggestions = data.map((item: any) => {
                let newItem: any = {};

                newItem.value = item.nom_conducteur + " " + item.prenom_conducteur;
                newItem.id = item.id_conducteur;

                return newItem;
            });

            applySelectedItems(getSuggestions);

            setAutocompleteState("");

            return getSuggestions;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const updateAllCheckboxState = (newItems: { value: string }[]) => {
        const updatedCheckboxStates = { ...checkboxStates };

        newItems.forEach((item) => {
            updatedCheckboxStates[item.value] = true; // Cocher tous les items
        });

        setCheckboxStates(updatedCheckboxStates);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            items: getCheckedItems(updatedCheckboxStates),
        }));
        setIsCreateButtonDisabled(Object.values(updatedCheckboxStates).every((checked) => !checked));
    };

    const setItems = async (newItem: any) => {
        if (inputTypeSearchValue != 14 && inputTypeSearchValue != 15) {
            const itemExists = itemsAlerts.some(
                (item) => item.value === newItem.value
            );
            if (!itemExists) {
                const updatedItemsReports = [...itemsAlerts, newItem];
                setItemsAlerts(updatedItemsReports);
                setAutocompleteState("autocomplete-state");
                setSuggestions([]);
                setItemSearch(newItem.value);
                const normalizedItem = normalizeAlarmItems([newItem])[0];
                const updatedCheckboxStates = {
                    ...checkboxStates,
                    [normalizedItem.value]: true,
                };
                setCheckboxStates(updatedCheckboxStates);
                setAlarm((prevAlarm) => ({
                    ...prevAlarm,
                    items: getCheckedItems(updatedCheckboxStates, updatedItemsReports),
                }));
                setIsCreateButtonDisabled(false);
                setSelectAll(updatedItemsReports.length > 0 && getCheckedItems(updatedCheckboxStates, updatedItemsReports).length === updatedItemsReports.length);
            } else {
                setAutocompleteState("autocomplete-state");
                // console.log("The item already exists in the list.");
            }
        }

        if (inputTypeSearchValue == 15) {
            // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
            const allVehicle = await getAutocompleteVehicle(newItem.id);
            setItemSearch(newItem.value);
            setAutocompleteState("autocomplete-state");
            setSuggestions([]);
        }

        if (inputTypeSearchValue == 14) {
            // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
            const allVehicle = await getAutocompleteVehicleByGroup(newItem.id);
            setItemSearch(newItem.value);
            setAutocompleteState("autocomplete-state");
            setSuggestions([]);
        }

        if (inputTypeSearchValue == 32) {
            // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
            const allDriver = await getAutocompleteDriversByIdUser(newItem.id);
            setItemSearch(newItem.value);
            setAutocompleteState("autocomplete-state");
            setSuggestions([]);

            applySelectedItems(allDriver);
        }
    };

    const [isCreateButtonDisabled, setIsCreateButtonDisabled] =
        useState<boolean>(true);

    const handleAlarmSelect = (alarms: { value: any; id: any }[]) => {
        setItemsAlerts(alarms);
        setIsCreateButtonDisabled(alarms.length === 0);
    };

    const handleAlarmGroupChange = (newIdAlarmGroup: any) => {
        setItemGroupSearch(newIdAlarmGroup.label);
        setAutocompleteGroupState("autocomplete-state");
        setAutocompleteStateIcon("search");
        setAlarmSuggestions([]);
        console.log(newIdAlarmGroup.value);
        console.log(newIdAlarmGroup.label);

        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            id_groupe_alarme: newIdAlarmGroup.value,
            name_groupe_alarme: newIdAlarmGroup.label,
        }));

        console.log(Alarm);
    };

    const handleAlarmNameChange = (newIdAlarmName: string) => {
        setItemGroupName(newIdAlarmName);
        setAlarm((prevAlarm) => ({
            ...prevAlarm,
            alarm_name: newIdAlarmName,
        }));

        console.log(Alarm);
    };

    const updateCheckboxState = (newItem: { value: any }) => {
        setCheckboxStates((prevStates) => ({
            ...prevStates,
            [newItem.value]: true,
        }));
    };

    const createAlarm = async () => {
        try {
            console.log("Form submitted", Alarm);
            if (Alarm.items.length === 0 || !Alarm.alarm_name.trim() || !Alarm.alarm_type) {
                toast.warn(translate("Please complete required fields"), {
                    position: "bottom-right",
                    autoClose: 2400,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                setButtonClicked(false);
                return;
            }

            const response = await fetch(`${backendUrl}/api/alarm/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id_user: Alarm.id_user,
                    items: Alarm.items,
                    alarm_metrics: Alarm.alarm_metrics,
                    alarm_name: Alarm.alarm_name,
                    alarm_type: Alarm.alarm_type,
                    id_groupe_alarme: Alarm.id_groupe_alarme,
                }),
                mode: "cors",
            });

            const alarmResponse = await response.json();
            console.log(alarmResponse);
            if (!response.ok || alarmResponse?.success === false) {
                throw new Error(alarmResponse?.message || "Alarm create failed");
            }

            toast.success(translate("Alarm create successfully"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            navigate("/alarms");

            // Handle the response as needed here
        } catch (error) {
            setButtonClicked(false);
            toast.warn(translate("Can't create Alarm"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            console.error("Error creating alarm:", error);
            // Handle errors as needed here
        }
    };

    const updateAlarm = async () => {
        try {
            console.log("Alarm form submitted", Alarm);
            if (Alarm.items.length === 0 || !Alarm.alarm_name.trim() || !Alarm.alarm_type) {
                toast.warn(translate("Please complete required fields"), {
                    position: "bottom-right",
                    autoClose: 2400,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                setButtonClicked(false);
                return;
            }

            const response = await fetch(`${backendUrl}/api/alarm/update`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id_alarme: Alarm.id_alarme,
                    id_user: Alarm.id_user,
                    items: Alarm.items,
                    alarm_metrics: Alarm.alarm_metrics,
                    alarm_name: Alarm.alarm_name,
                    alarm_type: Alarm.alarm_type,
                    id_groupe_alarme: Alarm.id_groupe_alarme,
                }),
                mode: "cors",
            });

            const alarmResponse = await response.json();
            console.log(alarmResponse);
            if (!response.ok || alarmResponse?.success === false) {
                throw new Error(alarmResponse?.message || "Alarm update failed");
            }

            toast.success(translate("Alarm update successfully"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            navigate("/alarms");

            // Handle the response as needed here
        } catch (error) {
            setButtonClicked(false);
            toast.warn(translate("Can't update alarm"), {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            console.error("Error update alarm:", error);
            // Handle errors as needed here
        }
    };

    const getAlarm = async () => {
        try {
            const res = await fetch(`${backendUrl}/api/alarm/find/${id_alarme}`, {
                mode: "cors",
            });

            if (!res.ok) {
                console.error("Error retrieving alarm");
                return;
            }

            const data = await res.json();
            const loadedItems = normalizeAlarmItems(data.items);
            const alarmTypeId = Number(data.id_type_alarme || 0);
            setAlarm({
                id_alarme: data.id_alarme,
                alarm_name: data.alarm_name,
                name_groupe_alarme: data.name_groupe_alarme,
                id_user: data.id_user,
                items: loadedItems,
                alarm_metrics: data.alarm_metrics,
                alarm_type: alarmTypeId,
                id_groupe_alarme: data.id_groupe_alarme,
                id_type_alarme: alarmTypeId,
                id_alarm_group: data.id_groupe_alarme,
            });

            console.log({
                id_alarme: data.id_alarme,
                alarm_name: data.alarm_name,
                name_groupe_alarme: data.name_groupe_alarme,
                id_user: data.id_user,
                items: data.items,
                alarm_metrics: data.alarm_metrics,
                alarm_type: data.alarm_type,
                id_groupe_alarme: data.id_alarm_group,
                id_type_alarme: data.id_type_alarme,
                id_alarm_group: data.id_alarm_group,
            });

            // Update the list and checkboxes
            setItemsAlerts(loadedItems);
            const initialCheckboxStates: { [key: string]: boolean } = {};
            loadedItems.forEach((item: { value: any }) => {
                initialCheckboxStates[item.value] = true; // Automatically check
            });
            setCheckboxStates(initialCheckboxStates);
            setSelectAll(loadedItems.length > 0);

            // Disable or enable the button depending on the elements
            setIsCreateButtonDisabled(loadedItems.length === 0);

            // Mise à jour des noms et types
            setItemGroupName(data.alarm_name);
            setItemGroupSearch(data.name_groupe_alarme || "");
            setSelectedAlarm(alarmTypeId || null);
        } catch (error) {
            console.error("Error retrieving alarm", error);
        }
    };

    useEffect(() => {
        if (id_alarme) {
            getAlarm();
            console.log(Alarm);
        }
    }, []); //

    const alarmOptions = [
        { value: "0", label: "-" },
        { value: "2", label: "Outside POI during forbidden time" },
        { value: "3", label: "No transmission" },
        { value: "4", label: "Accelerometer alarm (device)" },
        { value: "5", label: "iButton authentication alarm (device)" },
        { value: "6", label: "GPS jamming alarm (device)" },
        { value: "7", label: "GSM jamming alarm (device)" },
        { value: "8", label: "CAN alarm (device)" },
        { value: "9", label: "SIM credit alarm" },
        { value: "10", label: "iButton group alarm (device)" },
        { value: "11", label: "I/O alarm" },
        { value: "12", label: "Private mode alarm (device)" },
        { value: "13", label: "Specific iButton alarm (device)" },
        { value: "14", label: "Power interruption" },
        { value: "15", label: "Battery discharged (device)" },
        { value: "16", label: "Motion sensor (device)" },
        { value: "17", label: "Date/Time" },
        { value: "18", label: "Speed violation (device)" },
        { value: "19", label: "iButton error (device)" },
        { value: "20", label: "Ignition status (device)" },
        { value: "21", label: "Relay status (device)" },
        { value: "22", label: "Panic status (device)" },
        { value: "23", label: "Event counter EV1 increment" },
        { value: "24", label: "Event counter EV2 increment" },
        { value: "25", label: "Garmin interface or screen disconnected (device)" },
        { value: "26", label: "Engine started during forbidden time" },
        { value: "27", label: "Movement with engine off (device)" },
        { value: "28", label: "Memory full (device)" },
        { value: "29", label: "GPS signal level" },
        { value: "30", label: "GSM signal level" },
        { value: "31", label: "Number of resets" },
        { value: "32", label: "CAN odometer" },
        { value: "33", label: "GPS odometer" },
        { value: "34", label: "Points of interest" },
        { value: "35", label: "Relay activated" },
        { value: "36", label: "Relay disconnected (device)" },
        { value: "37", label: "CAN engine speed" },
        { value: "38", label: "Unknown GSM network" },
        { value: "39", label: "Invalid GPS signal (device)" },
        { value: "40", label: "Under-voltage (device)" },
        { value: "41", label: "Idling with engine on" },
        { value: "42", label: "Idling with engine on (device)" },
        { value: "43", label: "Vehicle parked with engine off (device)" },
        { value: "44", label: "Over-voltage (device)" },
        { value: "45", label: "CAN engine temperature" },
        { value: "46", label: "Daily mobile traffic (device)" },
        { value: "47", label: "Monthly mobile traffic (device)" },
        { value: "48", label: "Speed" },
        { value: "49", label: "POI Entry/Exit" },
        { value: "50", label: "POI Speed Violation" },
    ];

    const visibleAlarmOptions = alarmOptions.filter((option) => {
        const alarmValue = Number(option.value);

        return (
            alarmValue === 0 ||
            userPermissions.some(
                (perm) => perm.id_permission === alarmValue + 86
            )
        );
    });

    const selectedAlarmLabel =
        visibleAlarmOptions.find(
            (option) => Number(option.value) === Number(selectedAlarm)
        )?.label || "";

    const isStep2SubmitDisabled =
        buttonClicked || !Alarm.alarm_name.trim() || !Alarm.alarm_type;

    const getAlarmIcon = (alarmType: number | null) => {
        if ([18, 37, 48, 50].includes(Number(alarmType))) return "la-tachometer-alt";
        if ([2, 34, 49].includes(Number(alarmType))) return "la-map-marker-alt";
        if ([14, 15, 40, 44].includes(Number(alarmType))) return "la-battery-half";
        if ([32, 33].includes(Number(alarmType))) return "la-route";
        if ([29, 30, 38, 39].includes(Number(alarmType))) return "la-signal";
        if ([17, 26].includes(Number(alarmType))) return "la-clock";
        return "la-sliders-h";
    };

    const alarmReferenceItems = [
        {
            icon: "la-bell",
            title: translate("Alarm type"),
            text: translate("Defines the event that triggers the alarm."),
        },
        {
            icon: "la-users-cog",
            title: translate("Alarm group"),
            text: translate("Applies notification recipients, channels and shared delivery settings."),
        },
        {
            icon: getAlarmIcon(selectedAlarm),
            title: translate("Parameters"),
            text: translate("Complete only the thresholds and conditions required for the selected type."),
        },
    ];

    const getAlarmHelpText = (alarmType: number | null) => {
        const type = Number(alarmType);

        if ([2, 34, 49, 50].includes(type)) {
            return translate("Select the related POI zones and complete the required entry, exit or speed conditions.");
        }

        if ([18, 37, 48].includes(type)) {
            return translate("Set the speed or engine speed threshold that will trigger the alarm.");
        }

        if ([32, 33].includes(type)) {
            return translate("Set the distance threshold used by the odometer alarm.");
        }

        if ([14, 15, 40, 44].includes(type)) {
            return translate("Configure the power or battery threshold according to the device status.");
        }

        if ([29, 30, 38, 39].includes(type)) {
            return translate("Configure signal conditions to detect weak or invalid GPS/GSM status.");
        }

        if ([17, 26].includes(type)) {
            return translate("Configure the date, time or restricted schedule for this alarm.");
        }

        if (type === 3) {
            return translate("Set the maximum time without transmission before the alarm is triggered.");
        }

        return translate("Complete the fields required by the selected alarm type.");
    };

    return (
        <>
            <div id="content">
                <div id="add_alarm_wizard" className="wizard">
                    <ul className="steps">
                        <li
                            data-target="#step1"
                            className={step === 1 ? "active-step" : ""}
                        >
                            <span className="badge badge-info">1</span>{" "}
                            {translate("Alarm for")} <span className="chevron"></span>
                        </li>
                        <li className="ml-2 mr-2">
                            <i className="las la-exchange-alt"></i>
                        </li>
                        <li
                            data-target="#step2"
                            className={step === 2 ? "active-step" : ""}
                        >
                            <span className="badge badge-info">2</span>{" "}
                            {translate("Settings")}
                            <span className="chevron"></span>
                        </li>
                    </ul>
                </div>
                <div className="">
                    <form id="add_alarm_form" style={{ width: "100%" }}>
                        <input type="hidden" name="step" value={step} />
                        {step === 1 && (
                            <div
                                className="step-pane-bgr step-pane active panel panel-default"
                                id="step1"
                                style={{ marginTop: "5px", padding: "15px" }}
                            >
                                <div className="panel-body">
                                    <div className="row">
                                        <div
                                            className="col-md-4 col-sm-4"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <div
                                                className="input-group-addon input-sm"
                                                style={{ paddingRight: "15px", paddingTop: "3px" }}
                                            >

                                                {id_alarme
                                                    ? translate("Update alarm for")
                                                    : translate("Add alarm for")
                                                }

                                            </div>
                                            <div className="d-flex align-items-center">
                                                <i
                                                    className={`las la-file-alt icon-report search-icon`}
                                                    style={{ padding: "0px 5px", color: "#fff" }}
                                                />
                                                <select
                                                    id="add_report_for"
                                                    name="add_report_for"
                                                    onChange={(e) => addReportBy(e.target.value)}
                                                    className="form-control input-sm"
                                                >
                                                    <option value="1">{translate("Vehicles")}</option>
                                                    <option value="3">{translate("Drivers")}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div
                                            className="col-md-4 col-sm-4"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <SelectReport
                                                controlId="category_vehicule"
                                                label={translate("Search by") + translate("Type")}
                                                icon={SearchByIcon}
                                                options={searchTypeOptions}
                                                valueType={{
                                                    value: inputTypeSearchValue,
                                                    label: translate(inputTypeSearchLabel),
                                                }}
                                                onChange={searchBy}
                                                disabled={SelectReportState}
                                            />
                                        </div>
                                        <div
                                            className="col-md-4 col-sm-4"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <div
                                                className="input-group-addon input-sm"
                                                style={{ paddingRight: "15px", paddingTop: "3px" }}
                                            >
                                                {translate("Search by")}{" "}
                                            </div>
                                            <div>
                                                <div style={{ position: "relative" }}>
                                                    <div className="d-flex align-items-center">
                                                        <i
                                                            className={`las la-${autocompleteStateIcon} icon-report`}
                                                            style={{ padding: "0px 5px" }}
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={`${translate(inputAdvanceSearch)}`}
                                                            className="me-2"
                                                            aria-label={`${translate(inputAdvanceSearch)}`}
                                                            onChange={(e) => getAutocomplete(e.target.value)}
                                                            value={itemSearch}
                                                            disabled={SelectReportState}
                                                        />
                                                    </div>
                                                    <div
                                                        className={`autocomplete-items ${autocompleteState}`}
                                                        style={{ listStyleType: "none", padding: 0 }}
                                                    >
                                                        {suggestions &&
                                                            suggestions.map(
                                                                (suggestion: any, index: number) => (
                                                                    <div
                                                                        key={index}
                                                                        onClick={(e) => setItems(suggestion)}
                                                                    >
                                                                        <p id={suggestion.id}>
                                                                            {" "}
                                                                            {suggestion.value}
                                                                        </p>
                                                                    </div>
                                                                )
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12" style={{ marginTop: "15px" }}>
                                            <div className="row" style={{ marginBottom: "15px" }}>
                                                <div className="col-md-12">
                                                    <div
                                                        className=""
                                                        style={{
                                                            padding: "3px 9px",
                                                            border: "1px solid #ccc",
                                                            borderBottom: "0px",
                                                        }}
                                                    >
                                                        <input
                                                            id="mf_cb"
                                                            name="selectAll"
                                                            type="checkbox"
                                                            checked={selectAll}
                                                            onChange={handleSelectAllChange}
                                                        />
                                                        <span id="mf_title" style={{ fontWeight: "bold" }}>
                                                            {" "}
                                                            <span id="nbrofvehicule">
                                                                ({itemsAlerts.length})
                                                            </span>
                                                            {translate(alarmFor)}
                                                        </span>
                                                    </div>
                                                    <div
                                                        className="table-responsive"
                                                        id="scroll"
                                                        style={{
                                                            border: "1px solid #ccc",

                                                            padding: "5px 5px",
                                                            marginBottom: "15px",
                                                            overflow: "auto;",
                                                            display: "block;",
                                                            height: "333px",
                                                        }}
                                                    >
                                                        <ul
                                                            id="mf_list"
                                                            style={{
                                                                width: "100%",
                                                                padding: "5px",
                                                                listStyleType: "none",
                                                            }}
                                                        >
                                                            {itemsAlerts &&
                                                                itemsAlerts.map(
                                                                    (itemsAlert: any, index: number) => (
                                                                        <div key={index}>
                                                                            <input
                                                                                type="checkbox"
                                                                                data-id={itemsAlert.id} // Utilisez data-id pour stocker l'identifiant
                                                                                onChange={handleCheckboxChange}
                                                                                checked={
                                                                                    checkboxStates[itemsAlert.value] ||
                                                                                    false
                                                                                } // Ajoutez une valeur par défaut (false) pour éviter des erreurs
                                                                                value={itemsAlert.value} // Pour transmettre la valeur liée
                                                                                name={itemsAlert.value} // Le name doit être unique par valeur
                                                                            />
                                                                            {itemsAlert.value}
                                                                        </div>
                                                                    )
                                                                )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-footer">
                                    <Link
                                        to={`/alarms`}
                                        className="btn btn-outline-secondary  mr-2"
                                        data-toggle="Cancel"
                                        data-placement="top"
                                        title="Cancel"
                                    >
                                        <i
                                            className="fas fa-chevron-left"
                                            style={{ fontSize: "1.2em" }}
                                        ></i>
                                        {translate("Cancel")}
                                    </Link>
                                    <button
                                        className={`btn btn-outline-secondary  mr-2 ${isCreateButtonDisabled ? "disabled" : ""
                                            }`}
                                        type="button"
                                        name="set_params"
                                        disabled={isCreateButtonDisabled}
                                        onClick={addAlarmParams}
                                    >
                                        <i className="fas fa-chevron-right"></i> {translate("Next")}
                                    </button>
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div
                                className="step-pane panel panel-default"
                                id="step2"
                                style={{
                                    background: "transparent",
                                    border: "none",
                                    marginTop: "12px",
                                    padding: 0,
                                }}
                            >
                                <div className="panel-body" style={{ padding: "0 0 12px" }}>
                                    <div
                                        style={{
                                            background: "#ffffff",
                                            padding: 0,
                                        }}
                                    >
                                        <div
                                            className="d-flex align-items-center justify-content-end"
                                            style={{
                                                background: "transparent",
                                                gap: "12px",
                                                flexWrap: "wrap",
                                                marginBottom: "14px",
                                            }}
                                        >
                                            <div
                                                className="d-flex align-items-center"
                                                style={{ gap: "8px", flexWrap: "wrap" }}
                                            >
                                                <span
                                                    style={{
                                                        background: "#e0f2fe",
                                                        borderRadius: "999px",
                                                        color: "#075985",
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                        padding: "6px 10px",
                                                    }}
                                                >
                                                    {itemsAlerts.length} {translate(alarmFor)}
                                                </span>
                                                <details style={{ position: "relative" }}>
                                                    <summary
                                                        style={{
                                                            background: "#ffffff",
                                                            border: "1px solid #cbd5e1",
                                                            borderRadius: "6px",
                                                            color: "#334155",
                                                            cursor: "pointer",
                                                            fontSize: "12px",
                                                            fontWeight: 600,
                                                            listStyle: "none",
                                                            padding: "6px 10px",
                                                        }}
                                                    >
                                                        <i className="las la-question-circle" /> {translate("Help")}
                                                    </summary>
                                                    <div
                                                        style={{
                                                            background: "#ffffff",
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
                                                            minWidth: "310px",
                                                            padding: "10px",
                                                            position: "absolute",
                                                            right: 0,
                                                            top: "34px",
                                                            zIndex: 20,
                                                        }}
                                                    >
                                                        {alarmReferenceItems.map((item) => (
                                                            <div
                                                                className="d-flex"
                                                                key={item.title}
                                                                style={{ gap: "8px", padding: "7px 4px" }}
                                                            >
                                                                <i
                                                                    className={`las ${item.icon}`}
                                                                    style={{
                                                                        color: "#ff7e41",
                                                                        fontSize: "20px",
                                                                        marginTop: "2px",
                                                                    }}
                                                                />
                                                                <div>
                                                                    <strong
                                                                        style={{
                                                                            color: "#334155",
                                                                            display: "block",
                                                                            fontSize: "12px",
                                                                        }}
                                                                    >
                                                                        {item.title}
                                                                    </strong>
                                                                    <span style={{ color: "#64748b", fontSize: "12px" }}>
                                                                        {item.text}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </details>
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginLeft: "-8px", marginRight: "-8px" }}>
                                            <div className="col-md-4 col-sm-12" style={{ marginBottom: "14px" }}>
                                                <label htmlFor="alarm_type_rich" style={{ fontWeight: 600 }}>
                                                    {translate("Alarme type")}{" "}
                                                    <span
                                                        aria-label={translate("Defines the event that triggers the alarm.")}
                                                        tabIndex={0}
                                                        title={translate("Defines the event that triggers the alarm.")}
                                                        style={{
                                                            color: "#64748b",
                                                            cursor: "help",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <i className="las la-question-circle" />
                                                    </span>
                                                </label>
                                                <div className="d-flex align-items-center">
                                                    <i
                                                        className="las la-bell icon-report"
                                                        style={{ padding: "0px 8px 0 0", color: "#ff7e41" }}
                                                    />
                                                    <select
                                                        id="alarm_type_rich"
                                                        className="form-control input-sm"
                                                        value={selectedAlarm || "0"}
                                                        name="alarm_type"
                                                        required
                                                        onChange={(e) => {
                                                            handleAlarmTypeChange(e.target.value);
                                                        }}
                                                    >
                                                        <option value="0" disabled>
                                                            {translate("Select an alarm type")}
                                                        </option>
                                                        {visibleAlarmOptions
                                                            .filter((option) => Number(option.value) !== 0)
                                                            .map((option) => (
                                                                <option key={option.value} value={option.value}>
                                                                    {translate(option.label)}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12" style={{ marginBottom: "14px" }}>
                                                <label htmlFor="alarm_name_rich" style={{ fontWeight: 600 }}>
                                                    {translate("Alarm name")}{" "}
                                                    <span
                                                        aria-label={translate("Use a clear name so it is easy to find later.")}
                                                        tabIndex={0}
                                                        title={translate("Use a clear name so it is easy to find later.")}
                                                        style={{
                                                            color: "#64748b",
                                                            cursor: "help",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <i className="las la-question-circle" />
                                                    </span>
                                                </label>
                                                <div className="d-flex align-items-center">
                                                    <i
                                                        className="las la-edit icon-report"
                                                        style={{ padding: "0px 8px 0 0", color: "#ff7e41" }}
                                                    />
                                                    <input
                                                        className="form-control input-sm"
                                                        type="text"
                                                        name="alarm_name"
                                                        id="alarm_name_rich"
                                                        placeholder={translate("Example: Speed alert - Oran fleet")}
                                                        value={Alarm.alarm_name}
                                                        required
                                                        onInput={checkStep3}
                                                        onChange={(e) => {
                                                            handleAlarmNameChange(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-12" style={{ marginBottom: "14px" }}>
                                                <label htmlFor="id_groupe_alarme_rich" style={{ fontWeight: 600 }}>
                                                    {translate("Group alarm")}{" "}
                                                    <span
                                                        aria-label={translate("Use an alarm group to apply notification recipients, channels and shared settings.")}
                                                        tabIndex={0}
                                                        title={translate("Use an alarm group to apply notification recipients, channels and shared settings.")}
                                                        style={{
                                                            color: "#64748b",
                                                            cursor: "help",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <i className="las la-question-circle" />
                                                    </span>
                                                </label>
                                                <div style={{ position: "relative" }}>
                                                    <div className="d-flex align-items-center">
                                                        <i
                                                            className={`las la-users-cog ${autocompleteStateIcon} icon-report`}
                                                            style={{ padding: "0px 8px 0 0", color: "#ff7e41" }}
                                                        />
                                                        <Form.Control
                                                            type="text"
                                                            id="id_groupe_alarme_rich"
                                                            placeholder={translate("Search or select an alarm group")}
                                                            className="me-2 w-100"
                                                            aria-label={`${translate(InputAdvanceSearchGroup)}`}
                                                            onChange={(e) => getGroupsAlarm(e.target.value)}
                                                            value={itemGroupSearch}
                                                            disabled={SelectGroupState}
                                                        />
                                                    </div>
                                                    <div
                                                        className={`autocomplete-items ${autocompleteGroupState}`}
                                                        style={{
                                                            listStyleType: "none",
                                                            padding: 0,
                                                            width: "calc(100% - 28px)",
                                                            right: 0,
                                                        }}
                                                    >
                                                        {alarmSuggestions &&
                                                            alarmSuggestions.map(
                                                                (alarmSuggestion: any, index: number) => (
                                                                    <div
                                                                        key={index}
                                                                        onClick={() => {
                                                                            handleAlarmGroupChange(alarmSuggestion);
                                                                        }}
                                                                    >
                                                                        <p>{alarmSuggestion.label}</p>
                                                                    </div>
                                                                )
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                background: "#ffffff",
                                                border: "1px solid #e5e7eb",
                                                borderRadius: "8px",
                                                marginTop: "12px",
                                                minHeight: "150px",
                                                padding: "16px",
                                            }}
                                        >
                                            {selectedAlarm && (
                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{
                                                        background: "#f8fafc",
                                                        borderRadius: "6px",
                                                        color: "#475569",
                                                        gap: "8px",
                                                        marginBottom: "14px",
                                                        padding: "9px 11px",
                                                    }}
                                                >
                                                    <i
                                                        className={`las ${getAlarmIcon(selectedAlarm)}`}
                                                        style={{ color: "#ff7e41", fontSize: "20px" }}
                                                    />
                                                    <span style={{ fontSize: "13px" }}>
                                                        {getAlarmHelpText(selectedAlarm)}
                                                    </span>
                                                </div>
                                            )}
                                            {AlarmComponent ? (
                                                AlarmComponent
                                            ) : (
                                                <div
                                                    className="d-flex align-items-center justify-content-center"
                                                    style={{
                                                        color: "#64748b",
                                                        minHeight: "118px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <i
                                                            className="las la-sliders-h"
                                                            style={{
                                                                color: "#ff7e41",
                                                                display: "block",
                                                                fontSize: "28px",
                                                                marginBottom: "8px",
                                                            }}
                                                        />
                                                        <strong style={{ color: "#334155" }}>
                                                            {translate("Select an alarm type")}
                                                        </strong>
                                                        <p style={{ margin: "4px 0 0" }}>
                                                            {translate("The specific settings will appear here.")}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className="row"
                                        id="criteria"
                                        style={{ display: "none" }}
                                    >
                                        <div
                                            className="col-md-12 col-sm-12"
                                            style={{ marginTop: "2px" }}
                                        >
                                            <div className="input-group">
                                                <div
                                                    className="col-md-4 col-sm-3"
                                                    style={{ marginTop: "2px" }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        style={{ paddingRight: " 10px" }}
                                                    >
                                                        Alarme type:
                                                    </span>
                                                    <div className="input-group">
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`las la-bell  ${autocompleteStateIcon} icon-report`}
                                                                style={{ padding: "0px 5px" }}
                                                            />
                                                            <select
                                                                className="form-control input-sm"
                                                                value={selectedAlarm || "0"}
                                                                name="alarm_type"
                                                                onChange={(e) => {
                                                                    handleAlarmTypeChange(e.target.value);
                                                                }}
                                                            >
                                                                {alarmOptions
                                                                    .filter(option => {
                                                                        const alarmValue = Number(option.value);
                                                                        // on garde "-" ou les alarmes autorisées
                                                                        return (
                                                                            alarmValue === 0 ||
                                                                            userPermissions.some(
                                                                                perm => perm.id_permission === alarmValue + 86
                                                                            )
                                                                        );
                                                                    })
                                                                    .map(option => (
                                                                        <option key={option.value} value={option.value}>
                                                                            {translate(option.label)}
                                                                        </option>
                                                                    ))}

                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-md-4 col-sm-3"
                                                    style={{ marginTop: "2px" }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        style={{ paddingRight: " 10px" }}
                                                    >
                                                        {translate("Alarm name")}:
                                                    </span>
                                                    <div className="">
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`las la-edit ${autocompleteStateIcon} icon-report`}
                                                                style={{ padding: "0px 5px" }}
                                                            />
                                                            <input
                                                                className="form-control input-sm"
                                                                type="text"
                                                                name="alarm_name"
                                                                id="alarm_name"
                                                                placeholder="Name your alarm"
                                                                value={Alarm.alarm_name}
                                                                onInput={checkStep3}
                                                                onChange={(e) => {
                                                                    handleAlarmNameChange(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-md-4 col-sm-3"
                                                    style={{ marginTop: "2px" }}
                                                >
                                                    <span
                                                        className="input-group-addon"
                                                        style={{ paddingRight: " 10px" }}
                                                    >
                                                        {translate("Group alarm")}:{" "}
                                                    </span>
                                                    <div className="">
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`las la-users-cog ${autocompleteStateIcon} icon-report`}
                                                                style={{ padding: "0px 5px" }}
                                                            />
                                                            <Form.Control
                                                                type="text"
                                                                id="id_groupe_alarme"
                                                                placeholder={`${translate(
                                                                    "Set group of alarm"
                                                                )}`}
                                                                className="me-2 w-100"
                                                                aria-label={`${translate(
                                                                    InputAdvanceSearchGroup
                                                                )}`}
                                                                onChange={(e) => getGroupsAlarm(e.target.value)}
                                                                value={itemGroupSearch}
                                                                disabled={SelectGroupState}
                                                            />
                                                        </div>
                                                        <div
                                                            className={`autocomplete-items ${autocompleteGroupState}`}
                                                            style={{ listStyleType: "none", padding: 0 }}
                                                        >
                                                            {alarmSuggestions &&
                                                                alarmSuggestions.map(
                                                                    (alarmSuggestion: any, index: number) => (
                                                                        <div
                                                                            key={index}
                                                                            onClick={(e) => {
                                                                                handleAlarmGroupChange(alarmSuggestion);
                                                                            }}
                                                                        >
                                                                            <p> {alarmSuggestion.label}</p>
                                                                        </div>
                                                                    )
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="col-md-12 col-sm-12"
                                                style={{ margin: "30px 0" }}
                                            >
                                                {" "}
                                            </div>
                                        </div>
                                        <div
                                            className="col-md-3 col-sm-3"
                                            id="opts_cell"
                                            style={{ display: "none", marginTop: "2px" }}
                                        ></div>
                                        <div
                                            className="col-md-3 col-sm-3"
                                            id="extra_cell_inline"
                                            style={{ display: "none", marginTop: "2px" }}
                                        ></div>
                                    </div>
                                    <div className="row" style={{ display: "none" }}>
                                        <div
                                            className="col-md-12"
                                            id="extra_cell"
                                            style={{ marginTop: "10px" }}
                                        ></div>
                                    </div>
                                </div>
                                <div className="panel-footer">
                                    <button
                                        className="btn btn-outline-secondary  mr-2"
                                        type="button"
                                        name="back"
                                        onClick={wizardBack}
                                    >
                                        <i
                                            className="fas fa-chevron-left"
                                            style={{ fontSize: "1.2em", color: "#ff7e41" }}
                                        ></i>{" "}
                                        {translate("Previous")}
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary  mr-2"
                                        type="button"
                                        onClick={() => {
                                            setButtonClicked(true);

                                            id_alarme ? updateAlarm() : createAlarm();
                                        }}
                                        disabled={isStep2SubmitDisabled}
                                    >
                                        <i
                                            className="las la-bell"
                                            style={{ fontSize: "1.2em", color: "#ff7e41" }}
                                        ></i>
                                        {id_alarme
                                            ? translate("Update Alarm")
                                            : translate("Create Alarm")}
                                    </button>
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
};

export default Alarm;
